// extracted by mini-css-extract-plugin
export default {"main":"Login_main__LdCet","wrapper":"Login_wrapper__uwN6Z","formWrapper":"Login_formWrapper__44xww","title":"Login_title__zwglK"};